// extracted by mini-css-extract-plugin
var _1 = "MRDwycsi0K8wAhny1wRI";
var _2 = "m6dXQXYO83_sW65b8SMO";
var _3 = "JEFPbMatsQOYIojYMeEb";
var _4 = "KJ77ySGuy7pZ6GWIoYLN";
var _5 = "JWc8K5MSf9y3wpf_db1o";
var _6 = "kzsMca3HhGQCye01fsxJ";
var _7 = "_1UdSQX6I7gu9Y69ckD8w";
export { _1 as "controls", _2 as "image", _3 as "language", _4 as "progress", _5 as "title", _6 as "track", _7 as "version" }
